<template>
    <div class="col-12 mt-4">
        <div class="row">
            <div class="col-12 text-center mb-4">
                <h1>
                    <img src="/images/pg-logo-s.png" width="50px;" alt="Private Gym Beeldmerk"> Wat onze leden zeggen
                </h1>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/635d0a2c252cba2c02c95565"
                    name="Koen Boswinkel"
                    date="2022-10-29"
                    title="Ontspannen en respectvol"
                    text="Alles is voorhanden om een complete training te doen, ook als je daar niet veel ervaring mee hebt. Er is voldoende mogelijkheid voor begeleiding. De grote winst en het unieke punt ten opzichte van andere sportscholen is echter de sfeer: er is geen enkele vorm van judgement, geen opgepompt gedoe. Sterker nog, leden helpen elkaar onderling met oefeningen en brengen elkaar zo verder. Ontspannen en met respect voor elkaar sporten! Dat is voor mij echt de meerwaarde van Private Gym"
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/63402b34350baeeabe63907d"
                    name="Vito Rooderkerk"
                    date="2022-10-07"
                    title="Niet meer wachten op apparatuur"
                    text="Sinds 1,5 maand nu lid bij Private Gym en wat is het een verademing. Naast dat ik niet hoef te
                        wachten op apparatuur is het altijd schoon en werkt alles. Alles wat ik nodig heb voor een gedegen
                        krachttraining is aanwezig en doordat ik dus niet hoef te wachten op anderen ben ik zeker een half
                        uur sneller klaar met trainen dan voordat ik bij Private Gym zat. Dit is niet iets wat ik gewend was
                        vanuit grote sportscholen waar ik eerder heb getraind."
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/632818a26a3e1ed2c3d67c3d"
                    name="Allysian"
                    date="2022-09-19"
                    title="Alles wat je nodig hebt als serieuze sporter"
                    text="Not your average gym! Op een goede manier. Schoon, alles voor jezelf, fijne communicatie met Stan, goede sfeer in aankleding en tussen andere sporters. Een absolute aanrader."
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/6326e55e7f7a8621ee5eb60e"
                    name="Dane de Zeeuw"
                    date="2022-09-18"
                    title="Private Gym is een Gym waar je je eigen"
                    text="Private Gym is een Gym waar je je eigen programma zonder te wachten kan uitvoeren. Super efficiënt en met pure allure van een hedendaagse Gym."
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/632643096a3e1ed2c3d5b538"
                    name="Marijke Brugman"
                    date="2022-09-18"
                    title="Prettige sfeer"
                    text="Prettige sfeer, kleinschalig, individualistisch."
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/63259f136a3e1ed2c3d54739"
                    name="Pepert"
                    date="2022-09-17"
                    title="Mooie sportschool, geweldig concept"
                    text="Geweldig leuk concept dit: je sport in je eigen mini-gym in een grote ruimte met nog 6 mini-gyms. Ik zeg 'mini', maar ze zijn wel helemaal compleet, alles om een goeie workout eruit te knallen. Doordat je alles bij de hand hebt en niet hoeft te wachten tot iemand klaar is met precies de dumbbells die jij nodig hebt, train je heel efficiënt."
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/632596d77f7a8621ee5e1183"
                    name="Olivier"
                    date="2022-09-17"
                    title="Private Gym heeft een niveau waar de grote ketens niet aan kunnen tippen."
                    text="Prettige en transparante communicatie naar de klant. Zeer uitgebreid aanbod aan materiaal om te trainen, dusdanig dat zowel beginnend als ervaren sporter uit de voeten kan."
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/632596d77f7a8621ee5e1183"
                    name="Jesse"
                    date="2022-09-17"
                    title="Top plek!"
                    text="Het bevalt me enorm goed om hier te sporten! De rust is erg fijn en de mensen zijn aardig.Ook is het fijn dat je niet op andere mensen hoeft te wachten en dat je dus in een sneller tempo je schema kan afronden."
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/63258f807f7a8621ee5e0bb2"
                    name="Jot"
                    date="2022-09-17"
                    title="Schone gym"
                    text="Schone, nette, fijne gym"
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/63243a8b6a3e1ed2c3d45a6c"
                    name="Brent van den Belt"
                    date="2022-09-16"
                    title="Fitness zonder wachten op mijn gewenste tijden"
                    text="Bij Private Gym kan ik op mijn eigen eiland lekker sporten voor een betaalbare prijs. Alles ligt binnen handbereik! Hierdoor hoef ik niet meer te wachten op fitness apparatuur die ik graag wil gebruiken. Daarnaast werkt het inplannen top en kan ik sporten op mijn gewenste tijden. Zeer tevreden over de service!"
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/6320b74f6a3e1ed2c3d1d92b"
                    name="Kees Pomp"
                    date="2022-09-13"
                    title="Ik ben om!"
                    text="Ik ben zelf geen “fan” van een sportschool van het stereotype concept. Private Gym maakt het sporten een stuk aangenamer en leuker! Je kan er volledig je eigen gang gaan, wanneer je maar wil. De sfeer is er goed en de entourage is su-per!"
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/631ce1646a3e1ed2c3cf697c"
                    name="Yorick Sam"
                    date="2022-09-10"
                    title="Fantastische gym, 24/7 je eigen eiland"
                    text="Fantastische gym waar je een volledig powerrack tot je beschikking hebt, en dat 24/7. Nooit een drukke gym of moeten wachten op apparaten. Dit is voor mij de oplossing om te blijven gaan. Inmiddels 30 trainingen gedaan bij Private Gym en er zullen nog vele volgen."
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/631c87526a3e1ed2c3cf2618"
                    name="Robin Bergevoet"
                    date="2022-09-10"
                    title="Fantastische gym, 24/7 je eigen eiland"
                    text="Voor mij is privategym eindelijk een sportschool waar ik, met de gewenste begeleiding ongestoord kan fitnessen zonder mij opgelaten te voelen. Een nieuw concept wat mijns inziens een goede toevoeging is aan de wereld van fitness. Het kleinschalige maakt het ook persoonlijk, wat ik erg prettig vind in de ervaring."
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/631c68f87f7a8621ee57dee1"
                    name="Jeroen"
                    date="2022-09-10"
                    title="Fantastische gym, 24/7 je eigen eiland"
                    text="Vrij trainen op je eigen eiland zonder elke keer te moeten wachten tot je wat kan doen. Altijd open en goed betaalbaar. Alles ziet er keurig uit en door de constante temperatuur binnen is het heerlijk trainen. Kortom een top Gym."
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/631c68f87f7a8621ee57dee1"
                    name="Jeroen"
                    date="2022-09-10"
                    title="Je eigen 15m2 om te trainen"
                    text="Heerlijk op je eigen eiland trainen"
                ></review-box>
            </div>
            <div class="col-md-4 mb-2">
                <review-box
                    link="https://www.trustpilot.com/reviews/631c68f87f7a8621ee57dee1"
                    name="Dewi Steenbergen"
                    date="2022-09-10"
                    title="Aanrader!"
                    text="Rustig en fijn sporten. Alles is aanwezig! Aanrader. :)"
                ></review-box>
            </div>
        </div>
    </div>
</template>

<script>

import ReviewBox from "./ReviewBox";
export default {
    components: {ReviewBox},

    props: [],

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
